module.exports = __webpack_public_path__ + "static/diagram-71-2@2x-a43b4aea9d93f1695084440d57023bd7.png";